import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from './Modal_ViewInvoice';

import '../../../../css/qavaApp.css';
import '../css/zInternal_css.css';


export function UpdateApplicantModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewInterviewDetails, setViewInterviewDetails] = useState([]);
    let [viewOfferDetails, setViewOfferDetails] = useState([]);

    let [interview_status, setInterview_status] = useState(null);
    let [interview_date, setInterview_date] = useState(null);
    let [interview_time, setInterview_time] = useState(null);
    let [interview_assesment, setInterview_assesment] = useState(null);

    let [applicant_phoneNumber, setApplicant_phoneNumber] = useState(null);
    let [offer_status, setOffer_status] = useState(null);
    let [offer_date, setOffer_date] = useState(null);
    let [offer_amount, setOffer_amount] = useState(null);
    let [offer_document, setOffer_document] = useState(null);

    let [viewOfferDocumentModal, setViewOfferDocumentModal] = useState(false);



    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);

    let employeeCompanyRoleRef = useRef('individual_contributor');
    let requisitionNameRef = useRef();
    let requisitionResponsibilitiesRef = useRef();
    let requisitionQualificationsRef = useRef();
    let applicationDeadlineRef = useRef();

    let selectedFileRef = useRef();


    function getData_interviewStatus () {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_view_interview_data",
                user: acctID,
                xJobRequisitionID: props.data.requisitionID,
                xJobApplicationID: props.data.applicationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');


                setInterview_status(cols[10]);
                setInterview_date(cols[11]);
                setInterview_time(cols[12]);
                setInterview_assesment(cols[13]);


                setViewInterviewDetails((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisitionID: cols[0], 
                        application_id: cols[1], 
                        requisitionName: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        date_recieved: cols[9], 
                        interview_status: cols[10],
                        interview_date: cols[11],
                        interview_time: cols[12],
                        interview_assesment: cols[13],
    
                    })
                });
            } 
        })

    };
    

    function getData_offerStatus () {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_view_offer_data",
                user: acctID,
                xJobRequisitionID: props.data.requisitionID,
                xJobApplicationID: props.data.applicationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

           // alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setApplicant_phoneNumber(cols[7]);
                setOffer_status(cols[10]);
                setOffer_date(cols[11]);
                setOffer_amount(cols[12]);
                setOffer_document(cols[13]);

                setViewOfferDetails((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisitionID: cols[0], 
                        application_id: cols[1], 
                        requisitionName: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        date_recieved: cols[9], 
                        offer_status: cols[10],
                        offer_date: cols[11],
                        offer_amount: cols[12],
                        offer_document: cols[13],
    
                    })
                });
            } 
        })

    };
    
    function updateInterviewStatus()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74503_interview_status_update',
                user: acctID,
                xJobRequisitionID: props.data.requisitionID,
                xJobApplicationID: props.data.applicationID,
                xInterview_status: interview_status,
                xInterview_date: interview_date,
                xInterview_time: interview_time,
                xInterview_assessment: interview_assesment,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function updateOfferStatus()
    {

        
        let formData = new FormData();
        formData.append('Tracker', '74503_offer_status_update');
        formData.append('user', acctID);
        formData.append('schema', schema);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('xApplicantMobileNumber', applicant_phoneNumber);
        formData.append('xOffer_status', offer_status);
        formData.append('xOffer_date', offer_date);
        formData.append('xOffer_amount', offer_amount);
        formData.append('xOffer_document', offer_document);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function convertApplicantToOnboarding()
    {
        let formData = new FormData();
        formData.append('Tracker', '74503_convert_applicantToOnboarding');
        formData.append('user', acctID);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('xApplicantMobileNumber', applicant_phoneNumber);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function recindOffer()
    {
        let formData = new FormData();
        formData.append('Tracker', '74503_recind_offer');
        formData.append('user', acctID);
        formData.append('xJobRequisitionID', props.data.requisitionID);
        formData.append('xJobApplicationID', props.data.applicationID);
        formData.append('xApplicantMobileNumber', applicant_phoneNumber);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function handle_change(event)
    {

        //alert("in Handle change 1");
        //alert(event);
        //alert(event[0]);
        //alert(event[1]);

        if(event[0] == 'slide_1')
        {

            setInterview_status(event[1])
        }
        
        if(event[0] == 'slide_4')
        {

            setInterview_status(event[1])
            setRow_4(false);
        }
        
    }

    function viewInvoiceModalHandler(event) {


        setOffer_document(event[1]);
        setViewOfferDocumentModal(event[0]);

    }



    function closeModalHandler() {

        props.closeModal(false);
    }

    useEffect(() => {

        getData_interviewStatus();
        getData_offerStatus();

    }, [])  
    

    //alert("In Update Aplicant");
    //alert(interview_status);
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonContent className='bookedDetails_gridContent_multiple'>
        <IonSlides pager='true' className='custom-pagination' options={{ speed: 100 }}>
         <IonSlide>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonLabel for="employeeRole">Update Application Status </IonLabel>

                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                                <select name="applicant_status" id='applicant_status' defaultValue={props.data.application_status} onChange={(e) => handle_change(['slide_1', e.target.value])}>
                                    <option value='none'>Select</option>
                                    <option value='applicant'>Applicant</option>
                                    <option value='interview'>Interview</option>
                                    <option value='pending'>Pending</option>
                                    <option value='offer'>Offer</option>
                                    <option value='hired'>Hired</option>
                                    <option value='rejected'>Rejected</option>
                                    
                                </select>   
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonSlide>
            {(interview_status == 'pending' || interview_status == 'selected' || interview_status == 'interview' || interview_status == 'applicant') &&  <IonSlide>

                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonLabel>Interview Information</IonLabel>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Interview Date</IonText>
                        </IonCol>
                        <IonCol>
                            {row_1 == true && <IonInput type='date' placeholder='Select Date' onIonChange={(e) => setInterview_date(e.detail.value)}></IonInput>}
                            {row_1 == false && <IonText>{interview_date}</IonText>}
                        </IonCol>
                        {row_1 == false && <IonCol>
                            <IonButton onClick={() => setRow_1(true)}>Update</IonButton>
                        </IonCol>}
                        {row_1 == true && <IonCol>
                            <IonButton onClick={() => setRow_1(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Interview Time</IonText>
                        </IonCol>
                        <IonCol>
                            {row_2 == true && <IonInput type='text' placeholder='Enter Time' onIonChange={(e) => setInterview_time(e.detail.value)}></IonInput>}
                            {row_2 == false && <IonText>{interview_time}</IonText>}
                        </IonCol>
                        {row_2 == false && <IonCol>
                            <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                        </IonCol>}
                        {row_2 == true && <IonCol>
                            <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Interview Assessment</IonText>
                        </IonCol>
                        <IonCol>
                            {row_3 == true && <IonInput type='text' placeholder='Enter Time' onIonChange={(e) => setInterview_assesment(e.detail.value)}></IonInput>}
                            {row_3 == false && <IonText>{interview_assesment}</IonText>}
                        </IonCol>
                        {row_3 == false && <IonCol>
                            <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                        </IonCol>}
                        {row_3 == true && <IonCol>
                            <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonText>Interview Status</IonText>
                        </IonCol>
                        <IonCol>
                            {row_4 == false && <IonText>{interview_status}</IonText>}
                        </IonCol>
                        {row_4 == false && <IonCol>
                            <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                        </IonCol>}
                        {row_4 == true && <IonCol>
                            <select name="interview_status" id='interview_status' defaultValue={interview_status} onChange={(e) => handle_change(['slide_4', e.target.value])}>
                                <option value='none'>Select</option>
                                <option value='rejected'>Reject</option>
                                <option value='selected'>Select Applicant</option>
                            </select>
                        </IonCol>}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton  onClick={() => updateInterviewStatus()}>Save</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonSlide>}
           {(interview_status == 'pending' || interview_status == 'selected' || interview_status == 'job_offered' || interview_status == 'customer_accepted') && <IonSlide>
            {viewOfferDetails.map((detailData) =>   {
            return (
                <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Offer Information</IonLabel>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Date</IonText>
                            </IonCol>
                            <IonCol>
                                {row_1 == true && <IonInput type='date' placeholder='Enter Date' onIonChange={(e) => setOffer_date(e.detail.value)}></IonInput>}
                                {row_1 == false && <IonText>{offer_date}</IonText>}
                            </IonCol>
                            {row_1 == false && <IonCol>
                                <IonButton onClick={() => setRow_1(true)}>Update</IonButton>
                            </IonCol>}
                            {row_1 == true && <IonCol>
                                <IonButton onClick={() => setRow_1(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Ammount / Month</IonText>
                            </IonCol>
                            <IonCol>
                                {row_2 == true && <IonInput type='text' placeholder='Enter Amount' onIonChange={(e) => setOffer_amount(e.detail.value)}></IonInput>}
                                {row_2 == false && <IonText>{offer_amount}</IonText>}
                            </IonCol>
                            {row_2 == false && <IonCol>
                                <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                            </IonCol>}
                            {row_2 == true && <IonCol>
                                <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Document</IonText>
                            </IonCol>
                            <IonCol>
                                {row_3 == true && 
                                                <input
                                                    type="file"
                                                    accept=".doc,.docx,.pdf"
                                                    onChange={(event) => setOffer_document(event.target.files[0])}
                                                />}
                                {row_3 == false && <IonButton className='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.offer_document])}> View </IonButton>}
                            </IonCol>
                            {row_3 == false && <IonCol>
                                <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                            </IonCol>}
                            {row_3 == true && <IonCol>
                                <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Status</IonText>
                            </IonCol>
                            <IonCol>
                                <IonText>{offer_status}</IonText>
                            </IonCol>
                            {row_4 == false && <IonCol>
                                <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                            </IonCol>}
                            {row_4 == true && <IonCol>
                                <select name="offer_status" id='offer_status' default={offer_status} onChange={(e) => setOffer_status(e.target.value)}>
                                    <option value='none'>Select</option>
                                    <option value='send_offer'>send Offer</option>
                                    <option value='hired'>Hire</option>
                                    <option value='recind'>Recind</option>
                                </select>
                            </IonCol>}
                        </IonRow>
                        {offer_status != 'customer_accepted' && <IonRow>
                            <IonCol>
                                <IonButton onClick={() => updateOfferStatus()}>Save</IonButton>
                            </IonCol>
                        </IonRow>}
                        {offer_status == 'customer_accepted' && <IonRow>
                            <IonCol>
                                <IonButton onClick={() => convertApplicantToOnboarding()}>Convert to Onboarding</IonButton>
                            </IonCol>
                            <IonCol>
                                <IonButton onClick={() => recindOffer()}>Recind Offer</IonButton>
                            </IonCol>
                        </IonRow>}
                    </IonGrid>)}
            )}
            </IonSlide>}
        </IonSlides>
        </IonContent>

        <IonFooter className='appFooter_internal'>
            <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
        </IonFooter>
        {viewOfferDocumentModal == true && <ViewInvoiceModal openModal={ viewOfferDocumentModal } closeModal={() => setViewOfferDocumentModal(false)} data={{
                                        fileLocation: offer_document, 
                                        applicationID: props.data.applicationID, 
                                        }}></ViewInvoiceModal>}

        </IonModal>) : null}
    </React.Fragment>
    )
}